import { waLink } from "@/data/company";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

export const WhatsAppFloat = () => (
  <a
    href={waLink()}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chamar no WhatsApp agora"
    data-testid="whatsapp-floating-button"
    className="fixed bottom-5 right-5 z-50 rounded-full bg-brand-green hover:bg-brand-greenHover shadow-2xl flex items-center justify-center gap-2 px-4 py-3 text-white font-heading font-bold text-sm md:text-base animate-pulse-soft transition-colors"
  >
    <WhatsAppIcon className="w-7 h-7 md:w-8 md:h-8" />
    <span>Chamar no WhatsApp</span>
  </a>
);
